import React, { useState } from 'react';
import { DownOutlined, RightOutlined } from '@ant-design/icons';
import TriggerBadge from './TriggerBadge';
import MessageBubble from './MessageBubble';

const StepCard = ({ step, index, total }) => {
    const [open, setOpen] = useState(false);
    const isLast = index === total - 1;

    const handleToggle = () => setOpen(o => !o);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleToggle();
        }
    };

    return (
        <div style={{ display: 'flex', gap: 0 }}>
            {/* Spine */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 36, flexShrink: 0 }}>
                <div style={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    flexShrink: 0,
                    background: open ? '#4CAF50' : '#fff',
                    border: '2px solid #4CAF50',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 11,
                    fontWeight: 600,
                    color: open ? '#fff' : '#4CAF50',
                    transition: 'all 0.2s',
                }}>
                    {index + 1}
                </div>
                {!isLast && (
                    <div style={{
                        width: 2,
                        flex: 1,
                        minHeight: 12,
                        background: '#E6E6E6',
                    }} />
                )}
            </div>

            {/* Card */}
            <div
                role="button"
                tabIndex={0}
                aria-expanded={open}
                aria-label={`Step ${index + 1}: ${step.title}`}
                onClick={handleToggle}
                onKeyDown={handleKeyDown}
                style={{
                    flex: 1,
                    marginLeft: 12,
                    marginBottom: isLast ? 0 : 16,
                    background: '#fff',
                    border: `1px solid ${open ? '#A5D6A7' : '#E6E6E6'}`,
                    borderRadius: 6,
                    cursor: 'pointer',
                    overflow: 'hidden',
                    transition: 'border-color 0.2s, box-shadow 0.2s',
                    boxShadow: open ? '0 2px 8px rgba(0,0,0,0.06)' : '0 1px 3px rgba(0,0,0,0.04)',
                    outline: 'none',
                }}
            >
                {/* Header row */}
                <div style={{ padding: '12px 16px', display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                    <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                            <span style={{ fontWeight: 600, fontSize: 14, color: '#263238' }}>{step.title}</span>
                            {step.reply_type && <TriggerBadge type={step.reply_type} />}
                        </div>
                        {!open && step.response && (
                            <div style={{
                                fontSize: 12,
                                color: '#607D8B',
                                marginTop: 4,
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}>
                                {step.response.split('\n')[0]}
                            </div>
                        )}
                    </div>
                    <div
                        aria-hidden="true"
                        style={{
                            color: open ? '#4CAF50' : '#d1d5db',
                            fontSize: 12,
                            flexShrink: 0,
                            transition: 'color 0.2s',
                            marginTop: 2,
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        {open ? <DownOutlined /> : <RightOutlined />}
                    </div>
                </div>

                {/* Expanded content */}
                {open && (
                    <div style={{ padding: '0 16px 16px', borderTop: '1px solid #E6E6E6' }}>
                        <div style={{ paddingTop: 16 }}>
                            {step.response && <MessageBubble msg={step.response} />}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StepCard;
